<template>
  <div>
    <p>Tap a word, then tap a destination. You can also drag a word with your finger or mouse.</p>
    <p role="status">{{ selected ? `Move “${selected}” to…` : 'Choose a word to move.' }}</p>
    <div class="sorting-layout">
      <div v-for="zone in zones" :key="zone.id" class="sort-zone" :data-zone="zone.id">
        <button class="zone-target secondary" :disabled="disabled || !selected" @click="move(selected, zone.id)">{{ zone.label }} {{ selected ? '· Move here' : '' }}</button>
        <div class="card-grid"><button v-for="item in itemsFor(zone.id)" :key="item.id" class="move-card" :class="{ chosen: selected === item.id }" :aria-pressed="selected === item.id" :disabled="disabled" @click="choose(item.id)" @pointerdown="pointerStart($event, item.id)" @pointerup="pointerEnd" @pointercancel="pointer = null">{{ item.label }}</button></div>
      </div>
    </div>
    <button :disabled="disabled || Object.keys(state.placements).length !== stage.items.length" @click="$emit('action', { type: 'check' })">CHECK MY SORTING</button>
    <TaskFeedback :checked="state.checked" :correct="state.correct === true" />
  </div>
</template>
<script>
import TaskFeedback from './TaskFeedback.vue';
export default {
  components: { TaskFeedback }, props: { stage: Object, state: Object, disabled: Boolean }, emits: ['action'],
  data: () => ({ selected: null, pointer: null, dragged: false }),
  computed: { zones() { return [{ id: 'unplaced', label: 'Word cards' }, ...this.stage.zones]; } },
  methods: {
    itemsFor(zone) { return this.stage.items.filter(item => (this.state.placements[item.id] || 'unplaced') === zone); },
    choose(id) { if (this.dragged) { this.dragged = false; return; } this.selected = id; this.$emit('action', { type: 'sort_select', item_id: id }); },
    move(id, zone) { if (!id || this.disabled) return; this.$emit('action', { type: 'sort_move', item_id: id, zone_id: zone === 'unplaced' ? null : zone }); this.selected = null; },
    pointerStart(event, id) { if (this.disabled || event.button !== 0) return; this.dragged = false; this.pointer = { id, x: event.clientX, y: event.clientY }; event.currentTarget.setPointerCapture(event.pointerId); },
    pointerEnd(event) {
      if (!this.pointer) return;
      const pointer = this.pointer; this.pointer = null;
      if (Math.hypot(event.clientX - pointer.x, event.clientY - pointer.y) < 12) return;
      this.dragged = true;
      const zone = document.elementFromPoint(event.clientX, event.clientY)?.closest('[data-zone]');
      if (zone) this.move(pointer.id, zone.dataset.zone);
    }
  }
};
</script>
